import createEnum from 'scripts/lib/create_enum';

/**
 * The following configurations are for rendering the so-called "flexible profile cards".
 * In the customerProfileDef, these cards share the same "type" `ProfileCardType.FLEXIBLE_CARD`
 */
export const FlexibleCardConfigurationType = createEnum('LOOP_RETURNS');
